exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comparison-banner .slick-track {\n  margin: 0 auto;\n}\n.comparison-banner .comparison-details {\n  width: 260px;\n}\n.comparison-banner .comparison-details .comparison-icons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 13px;\n}\n.comparison-banner .comparison-details .comparison-icons img {\n  height: 64px;\n  width: 60px;\n}\n.comparison-banner .comparison-details h2, .comparison-banner .comparison-details h3 {\n  line-height: 21px;\n  font-size: 16px;\n  margin: 0 0 10px;\n}\n@media (min-width: 320px) and (max-width: 580px) {\n#home-service {\n    padding: 0;\n}\n}", ""]);

// exports
